<template>
  <div class="my-recommend-goods-list">
    <div class="" v-if="!horizontal">
      <div class="m-recommend-goods-title">精品推荐</div>
      <ul class="m-recommend-goods-list" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading"
        infinite-scroll-distance="10">
        <li class="m-recommend-goods-list-item" v-for="(item, index) in list" :key="index" @click="jumpTo(index)">
          <el-image class="m-recommend-goods-gallery" :src="item.thumbnail" :fit="'cover'"></el-image>
          <span class="m-recommend-goods-name">{{ item.title }}</span>
          <div class="m-recommend-goods-opt" v-if="isLogin">
            <div class="m-recommend-goods-price" v-if="item.price_type == 1 && isLogin">
              <span>
                <em>￥</em>
                {{ item.price }}
              </span>
            </div>
            <div class="m-recommend-goods-price" v-if="item.price_type == 2 && isLogin">
              <span>
                <em>￥</em>
                {{ item.prom_price }}
              </span>
            </div>
            <div class="m-recommend-goods-price" v-if="item.price_type == 3 && isLogin">
              <span>
                协议价：
                <em>￥</em>
                {{ item.agreement_price }}
              </span>
              <span>
                平台价：
                <em>￥</em>
                {{ item.price }}
              </span>
            </div>
            <!-- <div class="goods-opt">
            <button>购买</button>11
          </div>-->
          </div>
        </li>
      </ul>
    </div>
    <div class="m-recommend-goods-scroll" v-else>
      <div class="m-recommend-goods-ul">
        <div class="m-recommend-goods-item" v-for="(item, index) in list" :key="index" @click="jumpTo(index)">
          <img class="m-recommend-goods-img" :src="item.thumbnail" :alt="item.title" :title="item.title" />
          <span class="m-recommend-goods-name">
            {{ item.title }}
          </span>
          <div class="m-recommend-goods-opt" v-if="isLogin">
            <div class="m-recommend-goods-price" v-if="item.price_type == 1 && isLogin">
              <span>
                <em>￥</em>
                {{ item.price }}
              </span>
            </div>
            <div class="m-recommend-goods-price" v-if="item.price_type == 2 && isLogin">
              <span>
                <em>￥</em>
                {{ item.prom_price }}
              </span>
            </div>
            <div class="m-recommend-goods-price" v-if="item.price_type == 3 && isLogin">
              <span>
                协议价：
                <em>￥</em>
                {{ item.agreement_price }}
              </span>
              <span>
                平台价：
                <em>￥</em>
                {{ item.price }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
export default {
  name: "MyRecommendGoodsList",
  components: {
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters("user", ["isLogin"])
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    horizontal: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    jumpTo(index) {
      const { list } = this
      const { goods_id } = list[index]
      this.$router.push({ path: 'mgoodsDetail', query: { goods_id } })
    },
    loadMore() {
      this.$emit("scrollEnd", {})
    }
  },
  mounted() {
  }
};
</script>

<style>
.m-recommend-goods-title {
  display: block;
  margin: auto;
  text-align: center;
  font-size: 0.28rem;
  padding: 0.2rem 0;
  background: url(../../../../assets/images/mobile/fav_bg.png) no-repeat center;
  background-size: contain;
  width: 2.2rem;
}

.m-recommend-goods-item {
  width: 4rem;
  float: left;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 0.2rem;
}

.m-recommend-goods-item img {
  width: 2rem;
  height: 2rem;
}

.m-recommend-goods-name {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  font-size: 0.2rem;
  margin-top: 0.2rem;
  height:0.65rem;
  font-weight: bold;
  font-size: 0.26rem;
  text-align: left;
}

.m-recommend-goods-ul {
  display: flex;
  height: 100%;
}

.m-recommend-goods-scroll {
  overflow: hidden;
  overflow-x: scroll;
  /* height: 4rem; */
  -webkit-overflow-scrolling: touch;
}

.m-recommend-goods-opt {
  display: flex;
  justify-content: flex-start;
  width: 100%;
}

.m-recommend-goods-price {
  color: #f00;
}

.m-recommend-goods-price em{
  font-size: 0.24rem;
}

.m-recommend-goods-list {
  overflow: hidden;
  margin-bottom: 0.4rem
}

.m-recommend-goods-list-item {
  background: #fff;
  width: calc(49% - 0.6rem);
  float: left;
  margin-top: 0.2rem;
  border-radius: 0.2rem;
  padding: 0.2rem;
  margin-left: 0.2rem;
}

.m-recommend-goods-list-item:nth-child(2n + 1) {
  margin-right: 0;
}

.m-recommend-goods-list-item img {
  width: 3rem;
  height: 3rem;
  display: block;
  margin: auto;
}

.m-recommend-goods-price {
  color: #f00;
  font-weight: bold;
  font-size: 0.28rem;
}

.m-recommend-goods-gallery {
  width: 100%;
  border-radius: 0.2rem;
}

.m-recommend-goods-opt {
  margin-top: 0.2rem;
}
</style>


// WEBPACK FOOTER //
// src/pages/mobile/components/MyRecommendGoodsList/index.vue